<template>
  <div>
    <div class="heading-travel-policy">
      <span
        :class="
          hotelDailyCostWithExceptionsObj.isActive ? 'tag is-success' : 'tag'
        "
        >Standard</span
      >
      <div class="right-content">
        <div class="lefttext">
          <!-- <p class="paragrapgh">Average daily cost for exceptions cities</p> -->
          <!-- <p>Trigger when the daily cost for exceptions cities is more than  <u> -->
          <p class="paragrapgh">Average daily cost</p>
          <p>
            Trigger when the daily cost is more than

            <span class="rule-config-variable" @click="isEdit = !isEdit">
              {{
                hotelAverageDailyCostObj.value
                  ? "$" + hotelAverageDailyCostObj.value
                  : "N/A"
              }}
              <b-icon icon="pencil" size="is-small"></b-icon>
            </span>
          </p>

          <p>
            Hotel average nightly cost for exceptions cities is more than
            <span class="rule-config-variable" @click="isEdit = !isEdit">
              {{
                hotelDailyCostWithExceptionsObj.value.exceptionCitiesDailyCost
                  ? "$" +
                    hotelDailyCostWithExceptionsObj.value
                      .exceptionCitiesDailyCost
                  : "N/A"
              }}
              <b-icon icon="pencil" size="is-small"></b-icon>
            </span>
          </p>
          <p v-if="hotelDailyCostWithExceptionsObj.value.exceptionCities != ''">
            Exception cities:
            <span class="rule-config-variable" @click="isEdit = !isEdit">
              <span
                v-for="exceptionCity in hotelDailyCostWithExceptionsObj.value
                  .exceptionCities"
                :key="exceptionCity.index"
              >
                {{ exceptionCity[1] + "," }}
              </span>
              <b-icon icon="pencil" size="is-small"></b-icon>
            </span>
          </p>
        </div>
        <div class="allbtns">
          <!--<button @click="isEdit = !isEdit"><u v-if="!isEdit">EDIT</u><u v-if="isEdit">CANCEL</u></button>-->
          <b-switch
            :rounded="true"
            :value="hotelDailyCostWithExceptionsObj.isActive"
            v-model="hotelDailyCostWithExceptionsObj.isActive"
            @input="hotelDailyCostWithExceptions"
          >
          </b-switch>
        </div>
      </div>
    </div>
    <div v-if="isEdit" class="edittravelpolicy editTravel2">
      <HotelDailyCostWithExceptionCities
        @hotelDailyCostForExceptionCities="getValue"
        :hotelExceptionCities="propsData"
      />
      <p>Enter amount and select exception cities</p>
      <b-button @click="saveCall">SAVE</b-button>
    </div>
  </div>
</template>
<script>
import HotelDailyCostWithExceptionCities from "../CommonRules/HotelDailyCostWithExceptionCities.vue";
export default {
  name: "HotelDailyCostExceptionCities",
  props: {
    value: {
      type: [Object],
    },
  },
  components: { HotelDailyCostWithExceptionCities },
  data() {
    return {
      propsData: {
        dailyCost: null,
        exceptionCities: [],
        exceptionCitiesDailyCost: null,
      },

      hotelAverageDailyCostObj: {
        name: "hotelDailyCost",
        isActive: false,
        value: 500,
      },
      hotelDailyCostWithExceptionsObj: this.value
        ? this.value
        : {
            name: "hotelDailyCostWithExceptions",
            isActive: false,
            type: "hotel",
            message: "",
            value: {
              dailyCost: 200,
              exceptionCitiesDailyCost: 350,
              exceptionCities: [],
            },
          },
      isEdit: false,
      emitedValue: null,
      isTrue: null,
    };
  },
  methods: {
    saveCall() {
      this.isEdit = false;
      if (this.emitedValue || this.emitedValue == "") {
        this.hotelDailyCostWithExceptionsObj.value = this.emitedValue;
        this.hotelAverageDailyCostObj.value = this.emitedValue.dailyCost;
        /********* graving prop data  *********/
        this.propsData["dailyCost"] = this.emitedValue.dailyCost;
        this.propsData["exceptionCities"] = this.emitedValue.exceptionCities;
        this.propsData[
          "exceptionCitiesDailyCost"
        ] = this.emitedValue.exceptionCitiesDailyCost;

        // if(this.emitedValue.isSetExceptionCities){
        //     this.$emit('hotelDailyCostWithExceptions',this.hotelDailyCostWithExceptionsObj)
        // }
      }
    },
    getValue(val) {
      this.emitedValue = val;
      this.isTrue = val.isSetExceptionCities;
      // if (val.isSetExceptionCities == true) {
      //     this.hotelDailyCostWithExceptionsObj.name = "hotelDailyCostWithExceptions"
      // }
    },
    hotelDailyCostWithExceptions() {
      this.hotelDailyCostWithExceptionsObj.message = this.buildMessage;

      this.$emit(
        "hotelDailyCostWithExceptions",
        this.hotelDailyCostWithExceptionsObj
      );
    },
  },
  mounted() {
    this.hotelDailyCostWithExceptionsObj.type = "hotel";
    this.hotelDailyCostWithExceptionsObj.message = this.buildMessage;
    this.hotelAverageDailyCostObj.isActive = this.hotelDailyCostWithExceptionsObj.isActive;
    this.propsData.dailyCost = this.hotelAverageDailyCostObj.value;
    this.propsData.exceptionCitiesDailyCost = this.hotelDailyCostWithExceptionsObj.value.exceptionCitiesDailyCost;
    this.$emit(
      "hotelDailyCostWithExceptions",
      this.hotelDailyCostWithExceptionsObj
    );
  },
  computed: {
    buildMessage() {
      var string = "Trigger when the hotel daily cost is more than ";

      return (
        string +
        (this.hotelAverageDailyCostObj.value
          ? "$" + this.hotelAverageDailyCostObj.value
          : "N/A")
      );
    },
  },
  watch: {
    value: {
      handler(newVal, prevVal) {
        this.hotelDailyCostWithExceptionsObj = this.value;
        this.hotelDailyCostWithExceptionsObj.type = "hotel";
    this.hotelDailyCostWithExceptionsObj.message = this.buildMessage;
        this.$emit(
      "hotelDailyCostWithExceptions",
      this.hotelDailyCostWithExceptionsObj
    );
      },
      deep: true,
    },
  },
};
</script>
